import {Record, Static, String} from 'runtypes';

export const ServiceRuntype = Record({
    guid: String,
    title: String,
});

export type Service = Static<typeof ServiceRuntype>;
